


























import {Component, Vue, Prop, Watch, Emit} from "vue-property-decorator";
import {translate} from "@/services/translation/translation";
import {getHtmlUnit} from "@/services/unit/unit";
import './_number-slider-hight-light-images.less';
import $ from 'jquery';
import {goToTop} from "@/services/position/position";
import {string} from "prop-types";
import vueSlider from 'vue-slider-component'

@Component({
    components: {
        vueSlider,
    }
})

export default class numberSliderHightLightImages extends Vue {
    @Prop() model;

    private data: any = {
        model: null,
        options: {
            min: 0,
            max: 100000000000000
        }
    };
    mounted() {

        goToTop('', this.model.componentSetting.id);
        this.data.model = typeof this.model.componentSetting.default == "string" ? parseInt(this.model.componentSetting.default) : 0;
        this.data.options.min = typeof this.model.componentSetting.min == "string" ? parseInt(this.model.componentSetting.min) : 0;
        this.data.options.max = typeof this.model.componentSetting.max == "string" ? parseInt(this.model.componentSetting.max) : 0;

        this.setOpacity(this.data.options.min, this.data.options.max, this.data.model);

    }

    @Watch("model", {immediate: true, deep: true})
    changeModel(newVal, oldVal){
        if(this.data.model != null && (this.model.value_id == "" || this.model.value == "" ) ){
            this.changeComponentSettingModel(this.data.model);
        }
    }
    @Watch('data.model')
    changeValue(newValue) {
        this.setOpacity(this.data.options.min, this.data.options.max, newValue);
        this.changeComponentSettingModel(newValue);

    }

    public setOpacity(min, max, value) {

        var lenght = max - min;
        var step = lenght / 3;

        if (value <= step) {
            $('#'+this.model.componentSetting.id+' .house-image').css('opacity', 0.3);
            $('#'+this.model.componentSetting.id+' .house-image.small').css('opacity', 0.8);
        } else if (value > step && value <= step * 2) {
            $('#'+this.model.componentSetting.id+' .house-image').css('opacity', 0.3);
            $('#'+this.model.componentSetting.id+' .house-image.medium').css('opacity', 0.8);
        } else if (value > step * 2) {
            $('#'+this.model.componentSetting.id+' .house-image').css('opacity', 0.3);
            $('#'+this.model.componentSetting.id+' .house-image.big').css('opacity', 0.8);
        }
    }

    trans(key) {
        return translate(key);
    }

    getUnitView(unit){
        return getHtmlUnit(unit);
    }


    // @Watch("data.model", {immediate: true, deep: true})
    changeComponentSettingModel(newValue) {
        let componentValue :any = {};
        componentValue.id = this.model.componentSetting.id;
        componentValue.name = this.model.componentSetting.name;
        componentValue.value = newValue;
        componentValue.value_id = this.model.componentSetting.id;
        componentValue.next_question = this.model.componentSetting.next_question;
        componentValue.isEnableNext = this.model.isEnableNext;
        this.onSelectedQuestionValue(componentValue);

    }


    @Emit("selectedQuestionValue")
    onSelectedQuestionValue(value) {
    }

}

